export enum WorkspacePublicNetworkAccessType {
    Enabled = "Enabled",
    Disabled = "Disabled"
}